import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersNotifications } from "~/domains";

type RequestDataType = {
  page?: number;
};

const request = async ({
  page = 1,
}: RequestDataType): Promise<ApiMembersNotifications> => {
  const response = await new ApiClient().get<ApiMembersNotifications>(
    "/api/members/like_notifications",
    { page },
  );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersLikeNotificationsShow = ({
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiMembersNotifications> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersLikeNotificationsShow"],
    ({ pageParam }) => {
      return request({ page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
